import * as am5 from '@amcharts/amcharts5';
import { ChartLinearGradient, ChartTooltip, LineSerieChartData } from 'emma-common-ts/skudo';
import { compact, get, isNil } from 'lodash';

export const DEFAULT_CHART_COLORS = [0x14213d, 0xc73232, 0xf3a229, 0x6f747c, 0x9198a7, 0xe5e5e5];

export const getChartColorAtIndex = (index: number): number | undefined => {
  return DEFAULT_CHART_COLORS[index % DEFAULT_CHART_COLORS.length];
};

export const parseToColor = (color?: string | number): am5.Color | undefined => {
  if (color) {
    return am5.color(color);
  }
  return undefined;
};

export const getDefaultChartTooltipOptions = (): ChartTooltip => {
  return {
    autoTextColor: false,
    fillFromSprite: false,
    background: {
      color: 0xf3a229,
      opacity: 1,
    },
    label: {
      color: 0x14213d,
      fontWeight: '700',
    },
  };
};

export const getTooltip = (root: am5.Root, tooltip?: ChartTooltip): am5.Tooltip => {
  const tool = am5.Tooltip.new(root, {
    getFillFromSprite: tooltip?.fillFromSprite,
    getStrokeFromSprite: tooltip?.strokeFromSprite,
    autoTextColor: tooltip?.autoTextColor,
  });

  if (tooltip?.label) {
    tool.label.setAll({
      text: tooltip?.label.text,
      fill: parseToColor(tooltip?.label?.color),
      fontWeight: tooltip?.label?.fontWeight,
    });
  }

  if (tooltip?.background) {
    tool.get('background')?.setAll({
      fill: parseToColor(tooltip?.background?.color),
      fillOpacity: tooltip?.background.opacity,
    });
  }

  return tool;
};

export const getGradient = (root: am5.Root, gradient?: ChartLinearGradient): am5.LinearGradient => {
  return am5.LinearGradient.new(root, {
    rotation: gradient?.rotation,
    stops: gradient?.stops?.map((stop) => {
      return {
        opacity: stop.opacity,
        color: parseToColor(stop.color),
        offset: stop.offset,
      };
    }),
  });
};

export const parseLineChartData = (
  data: unknown[],
  labelKey: string,
  valueKey: string
): LineSerieChartData[] => {
  return compact(
    data.map((row) => {
      const label = get(row, labelKey) as string;
      const value = get(row, valueKey) as string | number;
      if (!isNil(label) && !isNil(value)) {
        const chartRow: LineSerieChartData = {
          label,
          value,
        };
        return chartRow;
      }
      return undefined;
    })
  );
};
